"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsRemoveKeywords = exports.googleAdsRemoveKeywordsResultSchema = exports.googleAdsRemoveKeywordsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var googleAdsRemoveKeywordsInputSchema = zod_1.z
    .object({
    criterionResourceName: zod_1.z
        .string()
        .describe('The resource name of the keyword to remove (e.g., customers/123/adGroupCriteria/456~789)'),
})
    .describe('Remove a Google Ads keyword.');
exports.googleAdsRemoveKeywordsArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsRemoveKeywordsInputSchema);
var googleAdsRemoveKeywordsResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    resourceName: zod_1.z.string().nullish(),
    message: zod_1.z.string().nullish(),
});
exports.googleAdsRemoveKeywordsResultSchema = googleAdsRemoveKeywordsResponseSchema;
exports.googleAdsRemoveKeywords = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleAdsRemoveKeywords',
    displayName: 'Google Ads Remove Keywords',
    displayDescription: 'Remove a Google Ads keyword. The keyword will be permanently removed and cannot be re-enabled.',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsRemoveKeywordsArgsSchema,
}, googleAdsRemoveKeywordsResponseSchema);
